import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

export const USER_ID_PLACEHOLDER = '$<userId>';

export const userIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(USER_ID_PLACEHOLDER)) {
    const authService = inject(AuthService);
    return from(authService.getUserId()).pipe(
      switchMap((userId) => {
        if (userId !== undefined) {
          const cloned = req.clone({
            url: req.url.replaceAll(USER_ID_PLACEHOLDER, userId),
          });
          return next(cloned);
        } else {
          // @@@todo error
          return next(req);
        }
      })
    );
  } else {
    return next(req);
  }
};
